import { createRouter, createWebHistory } from 'vue-router'
import UserLogin from '../components/Login.vue'
import UserRegister from '../components/Register.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ResetPassword from '../components/ResetPassword.vue'
import MainDashboard from '../components/Dashboard.vue'
import DashboardHome from '../views/DashboardHome.vue'
import DashboardAnalytics from '../views/DashboardAnalytics.vue'
import DashboardSettings from '../views/DashboardSettings.vue'
import ChatbotSettings from '../components/ChatbotSettings.vue'
import CreateChatbot from '../views/CreateChatbot.vue'
import ChatbotHomePage from '../views/ChatbotHomePage.vue'
import ChatbotList from '../components/ChatbotList.vue'
import AllUsersPage from '../views/AllUsersPage.vue'
import WhatsAppManagement from '../views/WhatsAppManagement.vue'
import PlaygroundView from '@/views/PlaygroundView.vue'
import ProfileView from '@/views/ProfileView.vue'
import AccountSettingsView from '@/views/AccountSettingsView.vue'
import FlowElementTest from '@/views/FlowElementTest.vue'
import JarvisKnowledgeView from '@/views/JarvisKnowledgeView.vue'
import VariablesView from '@/views/VariablesView.vue'

// Create a dummy dashboard component for now


const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'UserLogin',
    component: UserLogin
  },
  {
    path: '/register',
    name: 'UserRegister',
    component: UserRegister
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/flow-element-test',
    name: 'FlowElementTest',
    component: FlowElementTest,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'MainDashboard',
    component: MainDashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: DashboardHome
      },
      {
        path: 'chatbots',
        name: 'ChatbotList',
        component: ChatbotList
      },
      {
        path: 'analytics',
        name: 'DashboardAnalytics',
        component: DashboardAnalytics
      },
      {
        path: 'settings',
        name: 'DashboardSettings',
        component: DashboardSettings
      },
      {
        path: 'chatbots/create',
        name: 'CreateChatbot',
        component: CreateChatbot
      },
      {
        path: 'chatbots/:id/settings',
        name: 'ChatbotSettings',
        component: ChatbotSettings
      },
      {
        path: 'chatbots/:id/home',
        name: 'ChatbotHomePage',
        component: ChatbotHomePage
      },
      {
        path: 'all-users',
        name: 'AllUsersPage',
        component: AllUsersPage
      },
      {
        path: 'whatsapp_management',
        name: 'WhatsAppManagement',
        component: WhatsAppManagement
      },
      {
        path: 'chat/:chatbotId',
        name: 'Chat',
        component: () => import('@/views/ChatPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Chat'
        }
      },
      {
        path: 'chat/:chatbotId/:usertel',
        name: 'ChatWithUser',
        component: () => import('@/views/ChatPage.vue'),
        meta: {
          requiresAuth: true,
          title: 'Chat'
        }
      },
      {
        path: 'chatbots/:idchatbot/playground',
        name: 'playground',
        component: PlaygroundView,
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/:idchatbot/variables',
        name: 'ChatbotVariables',
        component: VariablesView,
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/:idchatbot/playground/:idblock',
        name: 'playgroundWithBlock',
        component: PlaygroundView,
        meta: { requiresAuth: true }
      },
      {
        path: 'profile',
        name: 'ProfileView',
        component: ProfileView,
        meta: { requiresAuth: true }
      },
      {
        path: 'account-settings',
        name: 'AccountSettingsView',
        component: AccountSettingsView,
        meta: { requiresAuth: true }
      },
      {
        path: 'chatbots/:idchatbot/jarvis-knowledge',
        name: 'JarvisKnowledgeView',
        component: JarvisKnowledgeView,
        meta: { requiresAuth: true }
      },
      // Routes temporaires pour éviter les erreurs de routing
      {
        path: 'transactions',
        name: 'Transactions',
        component: () => import('@/views/ComingSoonView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'orders',
        name: 'Orders', 
        component: () => import('@/views/ComingSoonView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'payouts',
        name: 'Payouts',
        component: () => import('@/views/ComingSoonView.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user') !== null

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next('/login')
    } else {
      next()
    }
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router 